<template lang="html">
  <div class="placed-backg your-experience-page" id="page-info-t1">
    <div class="bg-image"></div>

    <section class="container oversized-container content-section">
      <b-form class="row justify-content-center" @submit="onSubmit">
        <div class="col-12 col-s-title">
          <h1 class="text-center title">Califica tu experiencia</h1>
        </div>

        <div class="col-lg-5 col-xl-4 col-info">
          <div>
            <b-form-group class="c-form-group" label="Fecha de compra">
              <b-form-datepicker required v-model="form.fecha" locale="es" :max="max" v-bind="datepickerOpts" placeholder="Selecciona una fecha"></b-form-datepicker>
            </b-form-group>

            <b-form-group class="c-form-group" label="Sucursal">
              <b-form-select v-model="form.sucursal" :options="sucursales"></b-form-select>
            </b-form-group>

            <b-form-group class="c-form-group" label="Califica tu experiencia">
              <b-form-rating id="rating-inline" v-model="form.calificacion" size="lg" color="#ae2f3b" inline></b-form-rating>
            </b-form-group>

          </div>

        </div>

        <div class="col-lg-5 col-xl-4 col-info">
          <b-form-group class="c-form-group" label="Platícanos tu experiencia">
            <b-form-textarea
              v-model="form.msg"
              placeholder="Mensaje"
              rows="8"
              max-rows="8"
            ></b-form-textarea>
          </b-form-group>
        </div>

        <div class="col-12 mt-2 col-info" v-if="isloading == false">
          <p class="text-center" >
            <b-button type="submit" class="btn-send" >Enviar</b-button>
          </p>
        </div>
        <div class="col-12 mt-2 col-info" v-else style="text-align: center;">
          <div class="fa-3x"><i class="fas fa-spinner fa-pulse"></i></div>
          </div>
      </b-form>
    </section>
  </div>
</template>

<script>
export default {
  data(){
    const now = new Date()
    const today = new Date(now.getFullYear(), now.getMonth(), now.getDate())

    return{
      max: today,

      datepickerOpts: {
        labelHelp: 'Use las teclas de movimiento para navegar'
      },

      sucursales: [
        { value: 'MATRIZ', text: 'MATRIZ' },
        { value: 'ENCANTO', text: 'ENCANTO' },
        { value: 'DESCANSO', text: 'DESCANSO' },
        { value: 'BENITEZ', text: 'BENITEZ' },
        { value: 'OTAY', text: 'OTAY' },
        { value: 'CUCAPAH', text: 'CUCAPAH' },
        { value: 'FUNDADORES', text: 'FUNDADORES' },
        { value: 'ROSARITO', text: 'ROSARITO' },
        { value: 'RÍO', text: 'RÍO' },
        { value: 'SANTA FE', text: 'SANTA FE' },
        { value: 'DIAZ ORDAZ', text: 'DIAZ ORDAZ' },
       
        
      ],

      form: {
        fecha: null,
        sucursal: null,
        calificacion: null,
        msg: null
      },
      isloading:false,
    }
  },

  methods: {
    makeToast(variant = null, msg, title) {
      this.$bvToast.toast(msg, {
        title: title,
        variant: variant,
        solid: true,
        toaster: 'b-toaster-top-right',
        appendToast: true
      })
    },

    onSubmit(evt) {
      evt.preventDefault();
      this.isloading = true;
      //var data=tools.params(form, this.form);
      axios.post(tools.url("/api/calificar"), this.form).then((response)=>{
          this.makeToast('success', response.data.response, 'Mensaje enviado');
          this.form = {
            fecha: null,
            sucursal: null,
            calificacion: null,
            msg: null
          };

          this.isloading = false;
        }).catch( (error)=> {
          this.isloading = false;
        // console.log(error.response);
        let errors = error.response.data;
        // console.log(errors);
        this.makeToast('danger', error.response.data.fecha, 'Error');
        this.makeToast('danger', error.response.data.sucursal, 'Error');
        this.makeToast('danger', error.response.data.calificacion, 'Error');
        this.makeToast('danger', error.response.data.msg, 'Error');
      });
    }
  },
}
</script>
